<!-- Main Content Card -->
<div class="content-card">
  <div class="card-header">
    <h3 class="card-title">
      <svg>
        <use href="assets/icons.svg#document"></use>
      </svg>
      Sign agreement
    </h3>
  </div>
  <div class="card-intro">
    <svg>
      <use href="assets/icons.svg#document"></use>
    </svg>
    <p>Review and accept contract details</p>
  </div>

  <div class="card-content">
    <!-- Terms & Services -->
    <div class="agreement-terms">
      <ul>
        <li>
          <a
            href="https://www.teleauora.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            >Privacy policy</a
          >
        </li>
        <li>
          <a
            href="https://www.teleauora.com/acceptable-use-policy"
            target="_blank"
            rel="noopener noreferrer"
            >Acceptable use policy</a
          >
        </li>
        <li>
          <a
            href="https://www.teleauora.com/business-internet-services-terms-conditions"
            target="_blank"
            rel="noopener noreferrer"
            >Business internet services terms & conditions</a
          >
        </li>
        <li>
          <a
            href="https://www.teleauora.com/consumer-internet-services-terms-conditions"
            target="_blank"
            rel="noopener noreferrer"
            >Consumer internet services terms & conditions</a
          >
        </li>
      </ul>
    </div>

    <!-- Accept Contracts Section -->
    <div class="accept-contracts">
      <input type="checkbox" #termsCheckbox (change)="(0)" />
      <p>I agree to all terms & conditions</p>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="btn btn-secondary" type="button" (click)="goBack()">Back</button>
      <button
        class="btn btn-primary"
        type="button"
        (click)="submitOrder()"
        [disabled]="!termsCheckbox.checked"
      >
        Submit Order
      </button>
    </div>
  </div>
</div>
